
<div class="container-wrapper">
  <div class="d-flex justify-content-between align-items-center border mb-2">
      <ul class="nav nav-tabs mt-2 ms-2" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="Grafana-tab" data-bs-toggle="tab" data-bs-target="#Grafana"
            type="button" role="tab" aria-controls="Grafana" aria-selected="true" (click)="activeTab = 'Grafana'">
              Grafana 
              <a *ngIf="showLinkToTrustGrafanaURL" 
                  target="_blank" [href]="dashboardUrl" 
                  class="btn btn-sm p-0 ms-2 highlightButton" 
                  placement="top auto" triggers="hover" 
                  ngbTooltip="Verify Grafana Dashboard URL">
                    <i class="bi bi-box-arrow-up-right p-0 m-0 fw-bold" style="font-size: 15px"></i>
              </a>
          </button>
        </li>
        <li *ngIf="!isDeploymentAdmin" class="nav-item" role="presentation">
          <button class="nav-link" id="Dashboad-tab" data-bs-toggle="tab" data-bs-target="#Dashboad"
            type="button" role="tab" aria-controls="Dashboad" aria-selected="false" (click)="activeTab = 'Dashboard'">Dashboad</button>
        </li>
        <li class="nav-item" role="presentation" (click)="reloadDeploymentGraphComponent()">
          <button class="nav-link" id="Reports-tab" data-bs-toggle="tab" data-bs-target="#Reports"
            type="button" role="tab" aria-controls="Reports" aria-selected="false" (click)="activeTab = 'Reports'">Reports</button>
        </li>
      </ul>

      <span>
        <button *ngIf="activeTab == 'Grafana'" type="button" class="actionBtn me-2" (click)="reloadGrafanaDashboard()"
          triggers="hover" ngbTooltip="Refresh Grafana Dashboard">
          <span class="bi bi-arrow-clockwise"></span>
        </button>
        <span class="tab-update-label me-2"
        style="color: var(--s-primary-color);"
        [title]="lastRefreshedTime | date : 'yyyy-MM-dd, HH:mm:ss'">
        Last Update: {{ lastRefreshedTime | date : 'yyyy-MM-dd, HH:mm:ss' }}
      </span>
    </span>
  </div>
  
  <div class="tab-content" id="myTabContent" style="position: relative; min-height: 100px;">
    <!-- ! Grafana Start-->
    <div class="tab-pane fade show active" id="Grafana" role="tabpanel" aria-labelledby="Grafana-tab">
        <div>
            <div style="height: calc(100vh - 120px);">
                <iframe [src]="dashboardUrl" width="100%" height="100%" frameborder="0" ></iframe>
            </div>
        </div>
    </div>
    <!-- ! Grafana End-->

    <!-- ! Dashboard Start-->
    <ng-template [ngIf]="showDeploymentDashboard">
      <div class="tab-pane fade" id="Dashboad" role="tabpanel" aria-labelledby="Dashboad-tab">
          <div class="d-flex flex-column flex-grow-1 p-2"
               style="overflow-x: hidden; overflow-y: scroll !important; max-height: calc(100vh - 140px);">
            <div class="d-flex justify-content-end align-items-center mb-2">
              <div>
                <button type="button"
                        class="actionBtn"
                        (click)="editColoum()" style="border:none"
                        triggers="hover" ngbTooltip="Select charts to be shown">
                  <span><i class="bi bi-sliders"></i></span>
                </button>
              </div>

              <div>
                <button type="button"
                        class="actionBtn"
                        (click)="reloadDeploymentDashboardComponent()"
                        style="border:none"
                        triggers="hover" ngbTooltip="Refresh">
                  <span class="bi bi-arrow-clockwise"></span>
                </button>
              </div>
            </div>
            <!-- tiles -->
            <div class="row card-group text-center position-relative">
              <!-- cdkDropList [cdkDropListData]="dashboardData" (cdkDropListDropped)="drop($event)" -->
              <div class="my-2 col-md-15 col-sm-3" *ngFor="let db of dashboardData; let i= index">
                <!-- cdkDrag -->
                <div *ngIf="editedColumnList.includes(db.name)" class="card row m-0 mb-3">
                  <div class="card-header border-bottom-0 px-1 pb-0 d-flex align-items-center">
                    <figure (click)="onDataClick(db, -1)">
                      <blockquote class="blockquote"
                                  [ngClass]="db.subTitle != '' ? 'mb-3' : 'm-0'">
                        <h3 class="my-0 fw-bold text-dark flex-grow-1 text-start">
                          <i class="bi synchpc-primary text-dark fs-4"
                             [ngClass]="db.icon"></i>
                          {{ db.title }}
                        </h3>
                      </blockquote>
                      <figcaption [ngClass]="db.subTitle == '' ? 'p-2' : 'blockquote-footer'">
                        <cite title="Source Title">{{ db.subTitle }}</cite>
                      </figcaption>
                    </figure>
                    <div [ngClass]="db.subTitle != '' ? 'iconMargin' : ''">
                      <button [id]="i"
                              type="button"
                              class="dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                        <i class="bi bi-three-dots-vertical"></i>
                      </button>

                      <ul class="dropdown-menu" [aria-labelledby]="i">
                        <li>
                          <a class="dropdown-item" (click)="removeTile(db)">Remove</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="d-flex flex-column align-items-center mt-1">
                        <div class=""
                             (click)="onDataClick(db, 0)"
                             style="cursor: pointer;">
                          <div class="lh-1"
                               [style.color]="db.color"
                               style="letter-spacing: -0.025em; font-size: 3rem">
                            {{ db.data[0] }}
                          </div>
                          <div class="text-lg font-medium"
                               [style.color]="db.color"
                               style="font-size: 1.2rem">
                            {{ db.labels[0] }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-evenly w-100">
                          <ng-container *ngFor="let label of db.labels; let i = index">
                            <div *ngIf="i !== 0 && label !== ' '"
                                 class="d-flex flex-column alignitems-baseline justify-content-center w-100 mt-3 text-secondary"
                                 style="cursor: pointer;"
                                 (click)="onDataClick(db, i)">
                              <div class="text-md font-medium truncate">
                                {{ label }}
                              </div>
                              <div class="completedVal font-medium mt-2">
                                {{ db.data[i] }}
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                           size="default"
                           zIndex="1"
                           color="#0072c6"
                           type="ball-spin"
                           name="tiles"
                           [fullScreen]="false">
              </ngx-spinner>
            </div>

            <!--! Custom Data View -->
            <div *ngIf="customDataArray !== undefined || customDataArray.length !== 0"
                 class="p-3 card-group row">
              <div *ngFor="let customData of customDataArray; index as i"
                   class="customCard p-2"
                   [ngClass]="checkLengthCustomArray(i)">
                <div class="content-wrapper border border-rounded rounded-2 p-3">
                  <h3>
                    <span [matTooltip]="customData.description"
                          matTooltipPosition="right">{{ customData.title }}</span>
                  </h3>
                  <hr />

                  <div class="table-container">
                    <table class="table table-striped">
                      <thead>
                        <tr class="table-list-head">
                          <th *ngFor="let head of customData.header">{{ head }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-list-row" *ngFor="let innerObj of customData.body">
                          <td *ngFor="let head of customData.header">
                            {{ innerObj[head] }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--End of table container-->
                </div>
                <!--End of content wrapper-->
              </div>
              <!--End of custom card-->
            </div>
            <!--End of custom data component-->
            <!--! End of Custom Data View -->

            <div class="d-flex justify-content-end align-items-center m-2">
              <div>
                <button type="button"
                        class="actionBtn"
                        (click)="editChartsToShow()"
                        style="border:none"
                        triggers="hover"
                        ngbTooltip="Select charts to be shown">
                  <span><i class="bi bi-sliders"></i></span>
                </button>
              </div>
            </div>

            <div class="w-100 d-flex flex-wrap justify-content-evenly" style="background-color: aliceblue;">
              <div *ngIf="isChartVisible('nodeUtilization')" class="w-48 mt-4 p-3 pt-0 gaugeBlock shadow_block position-relative">
                <div class="mt-5 text-center"><label for="" class="fw-bold fs-6">Node utilization of last 1 Hour</label></div>
                <div class="gauges d-flex justify-content-evenly">
                  <div class="guage" (click)="navigateToComponent('cpu')">
                    <ngx-gauge matTooltip="Real-time average CPU percentage of all active nodes"
                               style="cursor: pointer; font-size: 1rem !important"
                               [size]="gaugeSize"
                               type="arch"
                               cap="round"
                               [value]="cpuGaugeValue"
                               [label]="cpuGaugeLabel"
                               matTooltipPosition="above"
                               [thick]="gaugeThick"
                               [thresholds]="gaugeThresholds"
                               [append]="gaugeAppendText"
                               (mouseenter)="onCpuGaugeHover()"
                               (mouseleave)="onCpuGaugeHover()">
                    </ngx-gauge>
                  </div>
                  <div class="guage" (click)="navigateToComponent('ram')">
                    <ngx-gauge matTooltip="Real-time average RAM percentage of all active nodes"
                               style="
                      cursor: pointer;
                      overflow: inherit;
                      font-size: 1rem !important;
                    "
                               [size]="gaugeSize"
                               matTooltipPosition="above"
                               type="arch"
                               cap="round"
                               [value]="ramGaugeValue"
                               [label]="ramGaugeLabel"
                               [thick]="gaugeThick"
                               [thresholds]="gaugeThresholds"
                               [append]="gaugeAppendText"
                               (mouseenter)="onRamGaugeHover()"
                               (mouseleave)="onRamGaugeHover()">
                    </ngx-gauge>
                  </div>
                  <div class="guage" (click)="navigateToComponent('gpu')">
                    <ngx-gauge matTooltip="Real-time average GPU Memory percentage of all active nodes"
                               style="
                      cursor: pointer;
                      overflow: inherit;
                      font-size: 1rem !important;
                    "
                               [size]="gaugeSize"
                               type="arch"
                               cap="round"
                               matTooltipPosition="above"
                               [value]="gpuMemoryGaugeValue"
                               [label]="gpuMemoryGaugeLabel"
                               [thick]="gaugeThick"
                               [thresholds]="gaugeThresholds"
                               [append]="gaugeAppendText"
                               (mouseenter)="onGpuGaugeHover()"
                               (mouseleave)="onGpuGaugeHover()">
                    </ngx-gauge>
                  </div>
                </div>
                <div class="mt-5">
                  <canvas baseChart
                          #nodeUtilizationChart="base-chart"
                          height="300px"
                          [data]="nodeUtilizationData"
                          [options]="nodeUtilizationOptions"
                          [plugins]="nodeUtilizationPlugins"
                          type="line"></canvas>
                </div>
                <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                             size="default"
                             zIndex="1"
                             color="#0072c6"
                             type="ball-spin"
                             name="usage"
                             [fullScreen]="false">
                </ngx-spinner>
              </div>
              <div *ngIf="isChartVisible('jobSessions') || isChartVisible('hpcUnits')" class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
                <div class="mt-5">
                  <div *ngIf="isChartVisible('jobSessions')" class="position-relative">
                    <canvas baseChart height="250" #jobSessionsChart="base-chart" [data]="jobSessionsData"
                            [options]="jobSessionsOptions" type="bar"></canvas>
                  </div>
                  <div *ngIf="isChartVisible('hpcUnits')" class="position-relative">
                    <canvas baseChart height="300" [data]="hpcUnitsConsumedDataTotal" [options]="hpcUnitsConsumedOptions"
                            [type]="hpcUnitsConsumedType" [plugins]="hpcUnitsConsumedPlugins">
                    </canvas>
                  </div>
                </div>
                <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                             size="default"
                             zIndex="1"
                             color="#0072c6"
                             type="ball-spin"
                             name="session"
                             [fullScreen]="false">
                </ngx-spinner>
                <ngx-spinner bdColor="rgba(0, 0, 0, 0)"
                             size="default"
                             zIndex="1"
                             color="#0072c6"
                             type="ball-spin"
                             name="hpcUnits"
                             [fullScreen]="false">
                </ngx-spinner>
              </div>
              <div *ngIf="isChartVisible('networkUsage')" class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
                <canvas class="border-r-1" style="background-color: white;" #networkChart="base-chart" baseChart [height]="graphHeight" [data]="networkData" [options]="networkOptions" [type]="networkType" [plugins]="networkPlugins">
                </canvas>
                <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                             size="default"
                             zIndex="1"
                             color="#0072c6"
                             type="ball-spin"
                             name="network"
                             [fullScreen]="false">
                </ngx-spinner>
              </div>
              <div *ngIf="isChartVisible('licenseUsage')" class="w-48 mt-4 p-3 pt-0 shadow_block border-r-1 position-relative">
                <canvas class="border-r-1" style="background-color: white;" #networkChart="base-chart" baseChart [height]="graphHeight" [data]="licenseUsageData" [options]="licenseUsageOptions" [type]="licenseUsageType" [plugins]="licenseUsage">
                </canvas>
                <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                             size="default"
                             zIndex="1"
                             color="#0072c6"
                             type="ball-spin"
                             name="license"
                             [fullScreen]="false">
                </ngx-spinner>
              </div>
            </div>
          </div>
      </div>
    </ng-template>
    <!-- ! Dashboard End-->

    <!-- ! Reports Start-->
    <div class="tab-pane fade" id="Reports" role="tabpanel" aria-labelledby="Reports-tab">
        <div class="body_container">
            <div class="row">
                <div class="col-md-12">
                    <app-deployment-graphs 
                      *ngIf="showDeploymentGraph" 
                      (refreshRequested)="reloadDeploymentGraphComponent()"
                    >
                    </app-deployment-graphs>
                </div>
            </div>
            <ngx-spinner
              bdColor="rgba(0,0,0,0)"
              size="default"
              zIndex="1"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false" name="loadingGraphs">
              <p class="pleaseWait">Please wait ...</p>
            </ngx-spinner>
        </div>
    </div>
    <!-- ! Reports End-->

    <ngx-spinner
      bdColor="rgba(0,0,0,0)"
      size="default"
      zIndex="1"
      color="var(--s-primary-color)"
      type="ball-spin"
      [fullScreen]="false" name="analytics">
      <p class="pleaseWait">Please wait ...</p>
    </ngx-spinner>
  </div>

</div>
